<mat-card class="my-5">
  <mat-card-header>
    <mat-card-title>Παραδομένες / Επεστραμένες</mat-card-title>
    <mat-card-subtitle>Ανά μήνα με ημερομηνία έγκρισης</mat-card-subtitle>
    <!--button mat-mini-fab class="refs-btn" color="primary" (click)="fetchData()" aria-label="Example icon button with a plus one icon">
            <i class="fas fa-redo"></i>
        </button-->
  </mat-card-header>
  <mat-card-content>
    <mat-divider></mat-divider>
    <div class="rdchart">
      <div style="text-align: center">
        <apx-chart
          #chartObj
          [series]="chartOptions.series"
          [chart]="chartOptions.chart"
          [xaxis]="chartOptions.xaxis"
          [yaxis]="chartOptions.yaxis"
          [title]="chartOptions.title"
          [grid]="chartOptions.grid"
          [dataLabels]="chartOptions.dataLabels"
          [stroke]="chartOptions.stroke"
          [colors]="chartOptions.colors"></apx-chart>
      </div>
    </div>
  </mat-card-content>
</mat-card>
